let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4SGJg")).then(() => parcelRequire('9MAJ7'));